export enum EHelpButtonArticles {
	SHOPIFY_DEV_APP = 'Creating the EAS App in Shopify',
	SHOPIFY_DEV_APP_CONFIGURE = 'Configuring Shopify Dev App',
}

export const HELP_CENTER_ARTICLE_URLS = {
	[EHelpButtonArticles.SHOPIFY_DEV_APP]:
		'https://help.easproject.com/hc/en-gb/articles/6473304471711-Creating-the-EAS-App-in-Shopify',
	[EHelpButtonArticles.SHOPIFY_DEV_APP_CONFIGURE]:
		'https://help.easproject.com/hc/en-gb/sections/6498002755231-Configuring-Shopify-Dev-App',
};
